import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './contexts/AuthContext';
import { MaintenanceProvider } from './contexts/MaintenanceContext';
import PlatformRestriction from './components/auth/PlatformRestriction';
import MaintenanceWrapper from './components/common/MaintenanceWrapper';
import theme from './theme/theme';
import AppRoutes from './AppRoutes';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const AppContent = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3}>
      <AuthProvider>
        <MaintenanceWrapper>
          <PlatformRestriction>
            <Router>
              <AppRoutes />
            </Router>
          </PlatformRestriction>
        </MaintenanceWrapper>
      </AuthProvider>
    </SnackbarProvider>
  </ThemeProvider>
);

const App = () => (
  <MaintenanceProvider>
    <AppContent />
  </MaintenanceProvider>
);

export default App;
